import { jsx as _jsx } from "react/jsx-runtime";
import { getOrderSeatCountForShowtime, getOrderTicketCountForShowtime } from '@vista/omnichannel-components-domain';
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { useShowtimeContext } from '../../../../context/showtime/hooks/use-showtime-context';
import { Counter } from '../../../../subcomponents/counter/counter';
import { TicketPickerContextInstance } from '../types/context';
const b = bemClassBuilder('v-ticket-picker-counter');
export const TicketPickerCounter = observer(({ style }) => {
    const { displayText } = useContext(TicketPickerContextInstance);
    const { showtimeId } = useShowtimeContext();
    const selectedSeatCount = getOrderSeatCountForShowtime(showtimeId);
    const selectedTicketCount = getOrderTicketCountForShowtime(showtimeId);
    return (_jsx("div", Object.assign({ className: b.block() }, { children: _jsx(Counter, { denominator: selectedSeatCount, numerator: selectedTicketCount, label: displayText.counterLabel, style: style }) })));
});
TicketPickerCounter.displayName = 'TicketPickerCounter';
